export default __webpack_public_path__ + "static/one-fam-trailer-271c7fabc4a57209c88e8e9e8b6c308f.mp4";